import React, { useState } from "react";
import { object, string, number, date, InferType } from 'yup';

import { TailwindInput } from "../../Tailwind";
import apiService from "../../../services/ApiService";
import { round } from "../../../tools";
import { useAppStore } from "../../../shared/stores/useAppStore";
import FieldDependenciesPanel from "./reusables/FieldDependenciesPanel";

export default function OutputFloatField({ name, field, scenarioId = null, onNavigate = undefined }) {
    const userSettings = useAppStore(s => s.userSettings);
    const resolvedScenarioId = scenarioId;
    const [showDeps, setShowDeps] = useState(false);

    const rawValue = field.is_percentage ? field.currentValue.value * 100 : field.currentValue.value;
    const value = rawValue && field.roundable ? round(rawValue, userSettings.roundPrecision).toLocaleString(userSettings.numberFormattingLocale, {maximumFractionDigits: userSettings.roundPrecision}) : rawValue;

    return (
        <div className="flex flex-row ml-3 items-start gap-1">
            <div className="flex flex-col">
                <TailwindInput
                    type="text"
                    value={value || ''}
                    placeholder={name}
                    error={field.compute_error || field.error}
                    helperText={field.compute_error || field.error}
                    suffix={field.is_percentage ? '%' : field.suffix}
                    readOnly={true}
                    className="h-10 mb-2 w-[200px]"
                />
            </div>
            <button
                onClick={() => setShowDeps(true)}
                className="mt-2 p-1 rounded hover:bg-slate-100 text-slate-400 hover:text-slate-600 transition-colors"
                title="View dependencies"
            >
                <span className="material-symbols-outlined text-[18px]">device_hub</span>
            </button>
            <FieldDependenciesPanel
                isOpen={showDeps}
                onClose={() => setShowDeps(false)}
                scenarioId={resolvedScenarioId}
                fieldId={field.id}
                fieldName={name}
                onNavigate={onNavigate}
            />
        </div>
    )
}
